import React from 'react'
import { Container, Row, Col, Image, Card } from "react-bootstrap";
import { Link } from "react-router";
import BlogBg from "../../Assets/about-bg.png";

export default function BlogBlock() {
    const data = [1, 2, 3];
    return (
        <section className="padding-section-large contact-section">
            <Container className="">
                <Row className='mb-4'>
                    <Col md={8}>
                        <h2 className="heading-style-h2 pb-3">Where We Make an <span className="text-gradient-1">Impact</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Every industry comes with its own challenges. We create software that responds to the pressures, pace, and priorities of each industry. </h5>
                    </Col>
                </Row>

                {/* Cards */}
                <Row>
                    {data.map((item, index) => (
                        <Col md={4} key={index} className="mb-4">
                            <Card className="impact-card h-100">
                                <Image src={BlogBg} />

                                <Card.Body>
                                    <small className="text-muted">6 Mar 2025</small>

                                    <Card.Text className="mt-2">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </Card.Text>

                                    {/* Footer */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="https://fastly.picsum.photos/id/0/5000/3333.jpg?hmac=_j6ghY5fCfSD6tvtcV74zXivkJSPIfR9B8w34XeQmvU"
                                                className="author-img me-2"
                                                alt="author"
                                            />
                                            <small>John Doe</small>
                                        </div>

                                        <small className="text-primary">6 min read</small>
                                    </div>
                                </Card.Body>

                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* Button */}
                <div className="text-center mt-4">
                    <Link className="btn btn-outline-dark rounded-pill text-uppercase ls-10">VIEW ALL</Link>
                </div>

            </Container>
        </section>
    )
}
